<div class="col-md-12 mb-30" *ngIf="Switcher_Form=='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Expense Title List</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Title</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button type="button" (click)="ReadData_Funds()" class="btn btn-info" style="margin-right: 5px;"><i
              class="fa  fa-search"></i> Search </button>
          <button (click)="Set_Add_Switcher_Form()"  type="button" class="btn btn-success" style="margin-right: 5px;"><i
              class="fa  fa-plus-circle"></i> Add New Record </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Status</th>
              <th>Deduction</th>
              <th>Date</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds
            |filter:Filter_title:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Funds|filter:Filter_title:'title').length
                      }
            ">
              <td>{{DataList_Funds.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>
                <p *ngIf="!item.del" style="color: #489b39;">Active</p>
                <p *ngIf="item.del" style="color: crimson;">Inactive</p>
              </td>
              <td>
                <p *ngIf="!item.minus" style="color: #489b39;">Do Not Deduct</p>
                <p *ngIf="item.minus" style="color: crimson;">Deduct</p>
              </td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a class="dropdown-item" style="cursor: pointer;" (click)="Set_Edit_Switcher_Form(item)"><i class="fa fa-edit"></i>
                        Edit </a>

                      <a *ngIf="item.del==false" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item)"><i class="fa fa-lock"></i> Inactive </a>
                      <a *ngIf="item.del==true" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item)"><i class="fa fa-unlock"></i> Active </a>

                      <a *ngIf="item.minus==false" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(templateminus,item)"><i class="fa fa-plus-circle"></i> Deduct </a>
                      <a *ngIf="item.minus==true" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(templateminus,item)"><i class="fa fa-minus-square"></i> Do Not Deduct </a>

                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<div *ngIf="Switcher_Form=='Form'">
  <app-FundsTitleForm

    [inner_Cabinent]="Data_Seleted_Delete"  >

  </app-FundsTitleForm>

  <button (click)="Set_Back_Switcher_Form()"  type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.del==false" class="modal-title pull-left">Approve Deactivate Expense Title
      '{{Data_Seleted_Delete.title}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete.del==true" class="modal-title pull-left">Approve Activate Expense Title
      '{{Data_Seleted_Delete.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.del==false" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> Deactivate <i class="fa fa-lock"></i></button>
    <button *ngIf="Data_Seleted_Delete.del==true" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> Activate <i class="fa fa-unlock"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateminus>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.minus==true" class="modal-title pull-left">Approve Do Not Deduct Information Expense Title
      '{{Data_Seleted_Delete.title}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete.minus==false" class="modal-title pull-left">Approve Deduct Information Expense Title
      '{{Data_Seleted_Delete.title}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.minus==true" type="button" class="btn btn-warning"
      (click)="Minus(Data_Seleted_Delete)"> Do Not Deduct <i class="fa  fa-minus-square"></i></button>
    <button *ngIf="Data_Seleted_Delete.minus==false" type="button" class="btn btn-warning"
      (click)="Minus(Data_Seleted_Delete)"> Deduct <i class="fa fa-plus-circle"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>
